import { render, staticRenderFns } from "./InventoryEventsDetail.vue?vue&type=template&id=c666db5a"
import script from "./InventoryEventsDetail.vue?vue&type=script&lang=js"
export * from "./InventoryEventsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c666db5a')) {
      api.createRecord('c666db5a', component.options)
    } else {
      api.reload('c666db5a', component.options)
    }
    module.hot.accept("./InventoryEventsDetail.vue?vue&type=template&id=c666db5a", function () {
      api.rerender('c666db5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/InventoryEventsDetail.vue"
export default component.exports